import { DeleteModal, DeleteModalProps, Modal } from "@app/components/modals"
import { ModalInstance } from "@app/hooks/useModal"
import { ITimesheet, IUser } from "@app/common";

interface TimesheetDeleteModalProps extends ModalInstance<ITimesheet>, Omit<DeleteModalProps<ITimesheet>, 'children'> {
  onDelete: (timesheet: Partial<ITimesheet>) => void;
}

export const TimesheetDeleteModal = (props: TimesheetDeleteModalProps) => {
  const user = props.data?.userId as unknown as IUser;
  const userName = user && typeof user === 'object' 
    ? `${user.firstname} ${user.lastname}` 
    : 'un utilisateur';

  return (
    <DeleteModal {...props}>
      <Modal.Subtitle>Vous allez supprimer le pointage de {userName}.</Modal.Subtitle>
      <Modal.Message>
        Cette suppression est irréversible.
      </Modal.Message>
    </DeleteModal>
  )
}

